import { z } from "zod";

export const JobApplicationStepKey = z.union([
  z.literal("CANDIDATE"),
  z.literal("DETAILS"),
  z.literal("FILES"),
  z.literal("QUESTIONNAIRE"),
  z.literal("WORKSTYLES"),
  z.literal("SUMMARY"),
]);

export type JobApplicationStepKey = z.infer<typeof JobApplicationStepKey>;
